<template>
  <div class='siderItem'>
    <div class="flex-col aic">
      <div class="gift-img pb10 csp" @click="changeGift" v-if="!userInfo.uid" v-show="webIcon">
        <img :src="webIcon" alt="" class="w100">
      </div>
      <div class="content">
        <template v-for="(item,i) in list">
          <div :key="i" class="csp content-box ovh" v-if="item.isShow !== false">
            <template v-if="item.isPop">
              <poptip-item :item="item" :className="`flex-col aic jcc`"></poptip-item>
            </template>
            <template v-else>
              <div class="flex-col aic jcc item-box" @click="changeEvent(item)">
                <div class="sider_icon " :class="item.iconClass"></div>
                <p class=" item-name">{{item.name}}</p>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'SiderItem',
  data () {
    return {
      list: [
        { name: '联系客服', type: 'kf', isPop: true, iconClass: 'sider_icon icon_1', },
        { name: '关注微信', type: 'wx', isPop: true, iconClass: 'sider_icon icon_2', },
        { name: 'APP下载', type: 'app', iconClass: 'icon_3' },
        { name: '返回顶部', type: 'top', isShow: false, iconClass: 'icon_4' },
      ],
      body_app: null,
      webIcon: '',
      webPoster: '',
			loginImg:'',
      timer: null,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'showUserGift']),
  },
  created () {
    this.getGift();
  },
  mounted () {
    this.body_app = document.getElementById('app');
    this.body_app.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    this.body_app.removeEventListener("scroll", this.handleScroll);
    this.body_app = null;
  },
  methods: {
    ...mapMutations(['setShowUserGift']),
    // 获取活动礼品图
    getGift () {
      this.http.NEWActiveRegister({ ...this.Product }).then(res => {
        this.webIcon = res.info.web_icon;
        this.webPoster = res.info.web_poster;
				this.loginImg = res.info.login_img;
        let rName = ['FooterDetails']; // 不出现弹窗的页面路径
        if (res.info.login_img && !this.showUserGift && !this.userInfo.uid && !rName.includes(this.$route.name)) {
          this.ShowGift({
            imgUrl: res.info.login_img
          });
          this.setShowUserGift(true);
        }
      }).catch(console.log);
    },
    // 点击礼品图
    changeGift () {
      this.ShowGift({
        imgUrl: this.webPoster || this.loginImg
      });
    },
    // 超过一屏显示返回顶部
    handleScroll () {
      let scrollTop = this.body_app.scrollTop;
      this.list.find(e => e.type === 'top').isShow = scrollTop >= window.innerHeight;
    },
    // app下载与返回顶部
    changeEvent (item) {
      switch (item.type) {
        case 'app':
          this.OpenRouter('/download');
          break;
        case 'top':
          if (this.body_app.scrollTop) {
            this.timer = setInterval(() => {
              this.body_app.scrollTop -= 150;
              if (this.body_app.scrollTop <= 0) {
                clearInterval(this.timer);
                this.timer = null;
                this.body_app.scrollTop = 0;
              }
            }, 16)
          }
          break;
      }
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../assets/less/function';
.spirit-curr {
  .spirit(url(../../assets/images/home_icon.png));
  &.icon_1 {
    &:after {
      width: 32px;
      height: 32px;
      background-position: -3px -126px;
    }
  }
  &.icon_11 {
    &:after {
      background-position: -39px -126px;
    }
  }
  &.icon_2 {
    &:after {
      width: 32px;
      height: 32px;
      background-position: -111px -126px;
    }
  }
  &.icon_22 {
    &:after {
      background-position: -75px -126px;
    }
  }
  &.icon_3 {
    &:after {
      width: 32px;
      height: 32px;
      background-position: -183px -126px;
    }
  }
  &.icon_33 {
    &:after {
      background-position: -147px -126px;
    }
  }
  &.icon_4 {
    &:after {
      width: 32px;
      height: 32px;
      background-position: -254.9px -126px;
    }
  }
  &.icon_44 {
    &:after {
      background-position: -219px -126px;
    }
  }
}

/deep/ .sider_icon {
  .spirit-curr;
}
.siderItem {
  .gift-img {
    width: 58px;
    height: 71px;
  }
  /deep/ .gift-img {
    + .content {
      .content-box {
        &:last-child {
          &:nth-child(2n) {
            .item-box {
              height: 72px;
            }
          }
          &:nth-child(2n + 1) {
            .item-box {
              height: 71px;
            }
          }
        }
      }
    }
  }
  /deep/ .content {
    box-shadow: 0px 4px 8px 0px rgba(0, 15, 34, 0.08);
    .content-box {
      &:first-child {
        .item-box {
          border-radius: 8px 8px 0px 0px;
        }
      }
      &:last-child {
        .item-box {
          border-radius: 0px 0px 8px 8px;
        }
      }

      &:not(:last-child) {
        .item-box {
          border-bottom: 1px solid #eee;
        }
      }
    }
  }

  /deep/ .item-box {
    width: 72px;
    height: 72px;
    background: #ffffff;
    color: #666f7a;
    font-size: 12px;

    .item-name {
      padding-top: 8px;
    }

    &:hover {
      color: #ffffff;
      background: #1177ff;
      .icon_1 {
        .spirit-curr .icon_11;
      }
      .icon_2 {
        .spirit-curr .icon_22;
      }
      .icon_3 {
        .spirit-curr .icon_33;
      }
      .icon_4 {
        .spirit-curr .icon_44;
      }
    }
    .item-icon {
      width: 28px;
      height: 28px;
    }
  }
}
.a {
  color: #000;
}
</style>
